@import '../../style/focus-outline.scss';

:host {
    --wcs-breadcrumb-item-max-height: var(--wcs-semantic-size-s);
    --wcs-breadcrumb-item-line-height: var(--wcs-semantic-font-line-height-large);
    --wcs-breadcrumb-item-font-size: var(--wcs-semantic-font-size-body-3);

    --wcs-breadcrumb-item-icon-color: var(--wcs-semantic-color-foreground-brand);
    --wcs-breadcrumb-item-icon-font-size: 0.5rem;
    --wcs-breadcrumb-item-gap: var(--wcs-semantic-spacing-base);

    --wcs-breadcrumb-item-link-color: var(--wcs-semantic-color-text-link-default);
    --wcs-breadcrumb-item-link-color-hover: var(--wcs-semantic-color-text-link-hover);
    --wcs-breadcrumb-item-link-font-weight: var(--wcs-semantic-font-weight-medium);

    --wcs-breadcrumb-item-border-width-focus: var(--wcs-semantic-border-width-large);

    --wcs-breadcrumb-item-border-color-focus: var(--wcs-semantic-color-border-focus-base);

    --wcs-breadcrumb-item-active-color: var(--wcs-semantic-color-text-primary);

    display: flex;
    align-items: baseline;
    max-height: var(--wcs-breadcrumb-item-max-height);
    font-size: var(--wcs-breadcrumb-item-font-size);
    color: var(--wcs-breadcrumb-item-active-color);
    line-height: var(--wcs-breadcrumb-item-line-height);

    ::slotted(a) {
        display: block;
        height: 100%;
        padding: 1px 2px;
        font-weight: var(--wcs-breadcrumb-item-link-font-weight);
        color: var(--wcs-breadcrumb-item-link-color);
        text-decoration: none;
        border-radius: var(--wcs-breadcrumb-item-border-width-focus);
    }
    ::slotted(a:focus-visible ) {
        @include focus-outline($outline-color: var(--wcs-breadcrumb-item-border-color-focus), $outline-offset: 0, $border-width: var(--wcs-breadcrumb-item-border-width-focus));
    }
    ::slotted(a:hover) {
        text-decoration: underline;
        color: var(--wcs-breadcrumb-item-link-color-hover);
    }

    .item-icon {
        margin-left: calc(var(--wcs-breadcrumb-item-gap) - 2px);
        font-family: "icons";
        font-size: var(--wcs-breadcrumb-item-icon-font-size);
        color: var(--wcs-breadcrumb-item-icon-color);
    }
}
